import styled from "styled-components";

export const Wrapper = styled.div`
  display: grid;

  grid-template-columns: 1fr;
  /* Com o cabeçalho opcional o grid ganha uma linha: sem isto o terceiro filho
     cairia numa linha implícita e a faixa das abas (1fr) esticaria. */
  grid-template-rows: ${(props) =>
    props.$hasHeader ? "auto auto 1fr" : "auto 1fr"};
  border-radius: 8px;
  background-color: transparent;
  ${(props) => props.fitContent && "height: fit-content;"}

  margin-top: ${(props) => (props.mt ? props.mt : "30px")};
`;

export const Tab = styled.button`
  place-self: end;

  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  letter-spacing: 0em;
  text-align: left;

  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  border-top-left-radius: 8px;
  border-top-right-radius: 8px;

  margin: 0px;
  background-color: ${({ theme, $active }) =>
    $active ? theme.colors.neutral.white : "transparent"};

  color: ${({ theme }) => theme.colors.neutral.black};
  border: none;
  padding: 14px 20px 14px 20px;

  box-shadow: ${(props) => props.$active && "0px 0px 5px rgba(0, 0, 0, 0.2)"};

  cursor: pointer;
`;

// Faixa acima das abas (nome do projeto, no detalhe do admin).
export const TopHeader = styled.div`
  padding: 0px 30px 12px;
`;

export const Header = styled.div`
  overflow: hidden;
  padding: 0px 30px;
  display: grid;

  grid-template-columns: repeat(auto-fill, minmax(0, auto));
  background-color: transparent;

  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
`;
export const Content = styled.div`
  padding: 20px 23px;
  background-color: ${({ theme }) => theme.colors.neutral.white};
  border-radius: 20px;
`;
